<template>
	<div>
		<NP-Modal
			class="cashbook-closal-modal"
			label="Закриття касової книги"
			:toggle="() => toggle({ loadingAction: true })"
			variant="sidebar"
		>
			<form @submit.prevent="apply" class="cashbook-closal-modal-content">
				<div>
					<div v-if="generalPage">
						<div class="banknotes-wrap">
							<NP-Banknotes
								v-model="cash"
								:banknote-denominations="banknoteDenominations"
								:coin-denominations="coinDenominations"
								:lists="root.lists"
								@total-amount="(amount) => (factual_amount = amount)"
								hide-totals
							/>
						</div>

						<p class="totals-header bold gray-50">Баланс</p>
						<CashbookTotals
							:factual-amount="factual_amount"
							:recorded-amount="recorded_amount"
							:discrepancy="discrepancy"
						/>

						<div class="print-checkboxes">
							<NP-Checkbox name="print_pages_per_month" v-model="print_pages_per_month">
								Вказати кількість аркушів за місяць
							</NP-Checkbox>
							<NP-Checkbox name="print_pages_per_year" v-model="print_pages_per_year">
								Вказати кількість аркушів за рік
							</NP-Checkbox>
						</div>
					</div>
					<div v-if="actPage" class="act-data">
						<p class="label bold">Здав/МВО</p>
						<div class="user-from">
							<NP-Input
								v-model="user_from_position"
								name="user_from_position"
								label="Посада"
								type="text"
								:error="localErrors.user_from_position || fieldErrors.user_from_position"
							/>
							<NP-Input :value="user_from_name" name="user_from_name" label="ПІБ" type="text" disabled />
						</div>
						<p class="label bold">Баланс</p>
						<CashbookTotals
							:factual-amount="factual_amount"
							:recorded-amount="recorded_amount"
							:discrepancy="discrepancy"
						/>
						<div class="line margin-bottom" />
						<div class="keys-and-plombetter">
							<div class="safe-keys">
								<NP-Input
									v-model="safe_keys_amount"
									name="safe_keys_amount"
									placeholder=""
									type="number"
									:error="fieldErrors.safe_keys_amount"
									:min="1"
									:decimal="0"
									:label="'Ключі від сейфу, шт.'"
								/>
							</div>

							<div class="plombeter_number">
								<NP-Input
									v-model="plombeter_number"
									name="plombeter_number"
									placeholder=""
									type="text"
									:error="fieldErrors.plombeter_number"
									:label="'Пломбір №'"
								/>
							</div>
						</div>

						<div class="sst-keys" v-if="hasSST">
							<div class="sst-safe-keys-amount">
								<NP-Input
									v-model="safe_sst_keys_amount"
									name="safe_sst_keys_amount"
									placeholder=""
									type="number"
									:error="fieldErrors.safe_sst_keys_amount"
									:min="1"
									:decimal="0"
									label="Ключі від фальш-дверей та сейфу ПТКС, шт."
								/>
							</div>
							<div class="sst-case-keys-amount">
								<NP-Input
									v-model="case_sst_keys_amount"
									name="case_sst_keys_amount"
									placeholder=""
									type="number"
									:error="fieldErrors.case_sst_keys_amount"
									:min="1"
									:decimal="0"
									label="Ключі від касети ПТКС, шт."
								/>
							</div>
						</div>

						<div class="line margin-bottom" />

						<p class="label bold">Пояснення</p>
						<div class="reason">
							<NP-Textarea v-model="reason" name="reason" :error="fieldErrors.reason" @keydown.enter="handleOnEnter" />
						</div>

						<p class="label bold">Голова комісії</p>
						<div class="committee-head">
							<NP-Input
								v-model="committee_head_position"
								name="committee_head_position"
								label="Посада"
								type="text"
								:error="fieldErrors.committee_head_position"
							/>
							<NP-SearchableInput
								id="committee_head"
								v-model="committee_head_name"
								:error="fieldErrors.committee_head_name"
								:options="committeeHeadOptions"
								:search-fn="(q) => _lookupUsers(q, 'committeeHeadOptions')"
								@select="(val) => onUserSelect(val, 'committee_head')"
								placeholder="ПІБ"
								open-direction="top"
							/>
						</div>

						<p class="label bold">Член комісії</p>
						<div class="committee-member">
							<NP-Input
								v-model="committee_member_position"
								name="committee_member_position"
								type="text"
								label="Посада"
								:error="fieldErrors.committee_member_position"
							/>
							<NP-SearchableInput
								id="committee_member"
								v-model="committee_member_name"
								:error="fieldErrors.committee_member_name"
								:options="committeeMemberOptions"
								:search-fn="(q) => _lookupUsers(q, 'committeeMemberOptions')"
								@select="(val) => onUserSelect(val, 'committee_member')"
								placeholder="ПІБ"
								open-direction="top"
							/>
						</div>
						<p class="label bold">Член комісії</p>
						<div class="committee-member">
							<NP-Input
								v-model="second_committee_member_position"
								name="second_committee_member_position"
								type="text"
								label="Посада"
								:error="fieldErrors.second_committee_member_position"
							/>
							<NP-SearchableInput
								id="second_committee_member"
								v-model="second_committee_member_name"
								:error="fieldErrors.second_committee_member_name"
								:options="secondCommitteeMemberOptions"
								:search-fn="(q) => _lookupUsers(q, 'secondCommitteeMemberOptions')"
								@select="(val) => onUserSelect(val, 'second_committee_member')"
								placeholder="ПІБ"
								open-direction="top"
							/>
						</div>
					</div>
				</div>
				<div class="buttons">
					<NP-Button
						type="submit"
						priority="high"
						class="close-cashbook-btn"
						:disabled="!validFactAmount || !validRecAmount"
						:loading="loadingActions.includes('setCashbookClosalData')"
					>
						{{ mainButtonTitle }}
					</NP-Button>
					<NP-Button priority="low" v-if="actPage" @click.stop="back"> Назад </NP-Button>
				</div>
			</form>
		</NP-Modal>
	</div>
</template>

<script>
import { validation } from 'novapay-ui';
import BigNumber from 'bignumber.js';

import { enum as banknoteDenominations } from '@repo/enums/banknote-denominations';
import { enum as coinDenominations } from '@repo/enums/coin-denominations';

const validateAmount = validation.compile({
	type: 'number',
	minimum: 0,
	multipleOf: 0.1,
	maximum: 99999999.99
});

export default {
	name: 'CashbookClosalModal',
	props: {
		toggle: { type: Function, default: null },
		setCashbookClosalData: { type: Function, default: null },
		toggleInventoryActModal: { type: Function, default: null },
		state: { type: [Object, String], default: null },
		root: { type: Object, default: null },
		loadingActions: { type: Array, default: null },
		errors: { type: Array, default: () => [] },
		lookupUsers: { type: Function, default: null }
	},
	data() {
		return {
			localErrors: [],
			committeeHeadOptions: [],
			committeeMemberOptions: [],
			secondCommitteeMemberOptions: [],
			banknoteDenominations,
			coinDenominations,
			cash: null,
			factual_amount: 0,
			user_from_name: `${this.root.user.last_name} ${this.root.user.first_name} ${this.root.user.patronymic || ''}`,
			user_from_position: this.root.user.position,
			print_pages_per_month: false,
			print_pages_per_year: false,
			generalPage: true,
			actPage: false,
			reason: null,
			safe_keys_amount: null,
			plombeter_number: this.root.salepoint.plombeter_number || null,
			safe_sst_keys_amount: null,
			case_sst_keys_amount: null,
			committee_head_name: null,
			committee_head_position: null,
			committee_member_name: null,
			committee_member_position: null,
			second_committee_member_name: null,
			second_committee_member_position: null
		};
	},
	computed: {
		recorded_amount() {
			return new BigNumber(this.root.cashbook.current_balance).toString();
		},
		validFactAmount() {
			let { errors } = validateAmount(this.factual_amount);
			return !errors;
		},
		validRecAmount() {
			let { errors } = validateAmount(this.recorded_amount);
			return !errors;
		},
		fieldErrors() {
			let errs = this.localErrors ? this.localErrors.concat(this.errors || []) : this.errors;
			return validation.computeValidationMessages(errs, [
				'user_from_position',
				'safe_keys_amount',
				'plombeter_number',
				'safe_sst_keys_amount',
				'case_sst_keys_amount',
				'reason',
				'committee_head_position',
				'committee_head_name',
				'committee_member_position',
				'committee_member_name',
				'second_committee_member_position',
				'second_committee_member_name'
			]);
		},
		discrepancy() {
			return new BigNumber(this.factual_amount).minus(this.recorded_amount).toNumber();
		},
		mainButtonTitle() {
			if (this.discrepancy && this.generalPage) {
				return 'Створити акт та ордер на розбiжнiсть';
			}
			return 'Закрити касову книгу';
		},
		hasSST() {
			return this.root.salepoint.virtual_salepoints_count > 0;
		}
	},
	methods: {
		handleOnEnter(e) {
			if (!e.shiftKey) {
				e.preventDefault();
				this.apply();
			}
		},
		apply() {
			if (!this.actPage && parseFloat(this.factual_amount) === 0 && !confirm('Ви впевнені, що фактична сума 0?')) {
				return;
			}
			if (this.discrepancy && this.generalPage) {
				this.actPage = true;
				this.generalPage = false;
				return;
			}
			if (this.discrepancy) {
				if (!(this.user_from_position || '').trim().length) {
					this.localErrors = [{ dataPath: 'user_from_position', message: `обов'язкове поле` }];
					return;
				}
				if (
					this.committee_head_name &&
					(this.committee_head_name === this.committee_member_name ||
						this.committee_head_name === this.second_committee_member_name)
				) {
					this.localErrors = [
						{ dataPath: 'committee_head_name', message: `не повинно дорівнювати Члену комісії` },
						{ dataPath: 'committee_member_name', message: `не повинно дорівнювати Голові комісії` },
						{ dataPath: 'second_committee_member_name', message: `не повинно дорівнювати Голові комісії` }
					];
					return;
				}

				if (this.committee_member_name && this.committee_member_name === this.second_committee_member_name) {
					this.localErrors = [
						{ dataPath: 'committee_member_name', message: `не повинно дорівнювати iншому члену комісії` },
						{ dataPath: 'second_committee_member_name', message: `не повинно дорівнювати iншому члену комісії` }
					];
					return;
				}
				if (!(this.reason || '').trim().length) {
					this.localErrors = [{ dataPath: 'reason', message: `обов'язкове поле` }];
					return;
				}
				if (this.committee_head_position && !this.committee_head_name) {
					this.localErrors = [{ dataPath: 'committee_head_name', message: `обов'язкове поле` }];
					return;
				}
				if (this.committee_head_name && !this.committee_head_position) {
					this.localErrors = [{ dataPath: 'committee_head_position', message: `обов'язкове поле` }];
					return;
				}
				if (this.committee_member_position && !this.committee_member_name) {
					this.localErrors = [{ dataPath: 'committee_member_name', message: `обов'язкове поле` }];
					return;
				}
				if (this.committee_member_name && !this.committee_member_position) {
					this.localErrors = [{ dataPath: 'committee_member_position', message: `обов'язкове поле` }];
					return;
				}
				if (this.second_committee_member_position && !this.second_committee_member_name) {
					this.localErrors = [{ dataPath: 'second_committee_member_name', message: `обов'язкове поле` }];
					return;
				}
				if (this.second_committee_member_name && !this.second_committee_member_position) {
					this.localErrors = [{ dataPath: 'second_committee_member_position', message: `обов'язкове поле` }];
					return;
				}

				if (this.hasSST) {
					if (!this.safe_sst_keys_amount) {
						this.localErrors = [{ dataPath: 'safe_sst_keys_amount', message: `обов'язкове поле` }];
						return;
					}

					if (!this.case_sst_keys_amount) {
						this.localErrors = [{ dataPath: 'case_sst_keys_amount', message: `обов'язкове поле` }];
						return;
					}
				}
			}
			return this.setCashbookClosalData({
				cash: this.cash,
				print_pages_per_month: this.print_pages_per_month,
				print_pages_per_year: this.print_pages_per_year,
				user_from_id: this.root.user.id,
				user_from_name: this.user_from_name,
				user_from_position: this.user_from_position,
				user_to_id: this.root.user.id,
				user_to_name: `${this.root.user.last_name} ${this.root.user.first_name} ${this.root.user.patronymic || ''}`,
				user_to_position: this.root.user.position,
				safe_keys_amount: this.safe_keys_amount,
				plombeter_number: this.plombeter_number,
				safe_sst_keys_amount: this.safe_sst_keys_amount,
				case_sst_keys_amount: this.case_sst_keys_amount,
				reason: this.reason,
				committee_head_position: this.committee_head_position,
				committee_head_name: this.committee_head_name,
				committee_member_position: this.committee_member_position,
				committee_member_name: this.committee_member_name,
				second_committee_member_position: this.second_committee_member_position,
				second_committee_member_name: this.second_committee_member_name,
				loadingAction: true
			});
		},
		back() {
			this.actPage = false;
			this.generalPage = true;
		},
		_lookupUsers(query, field) {
			return this.lookupUsers({
				query,
				id: field,
				cb: (res) => {
					this[field] = res.data;
				}
			});
		},
		onUserSelect(result, field) {
			let text = result.text && result.text.includes('(') ? result.text.split('(')[0].trim() : result.text;
			this[`${field}_name`] = text;
			this[`${field}_position`] = result.position || '';
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/variables.scss';

.cashbook-closal-modal {
	::v-deep .modal-container {
		display: flex;
		flex-direction: column;
		& .modal-body {
			height: 100%;
		}
		.cashbook-closal-modal-content {
			margin: auto;
			box-sizing: border-box;
			width: 555px;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			.label {
				margin-bottom: 12px;
				color: $gray-50;
			}
			.user-from {
				display: flex;
				align-items: flex-end;
				margin-bottom: 16px;
				font-size: 14px;
				justify-content: space-between;
				.input,
				.np-select {
					flex-grow: 1;
					&.has-error {
						::v-deep label {
							margin-top: 0;
						}
					}
					&:first-child {
						margin-right: 24px;
					}
				}
				.searchable-input {
					width: 257px;
				}
				.reason-number-and-date {
					display: flex;
					width: 257px;
					.input {
						flex-grow: 1;
					}
				}
				::v-deep .np-select {
					width: 200px;
				}
			}
		}
		.banknotes-wrap {
			display: flex;
			width: 555px;
		}
		.totals-header {
			margin: 24px 0;
		}
		.print-checkboxes {
			margin-top: 24px;
			.checkbox {
				display: block;
				margin-top: 8px;
			}
		}
		.act-data {
			.label {
				margin-bottom: 12px;
				color: $gray-50;
			}
			.line {
				width: 100%;
				margin-top: 24px;
				border-bottom: 1px solid $gray-10;
			}
			.margin-bottom {
				margin-bottom: 24px;
			}
			.factual-amount,
			.committee-head,
			.committee-member,
			.safe-keys,
			.sst-safe-keys-amount,
			.act-occasion-and-reason {
				display: flex;
				align-items: flex-end;
				margin-bottom: 16px;
				font-size: 14px;
				justify-content: space-between;
				.input,
				.np-select {
					flex-grow: 1;
					&.has-error {
						::v-deep label {
							margin-top: 0;
						}
					}
					&:first-child {
						margin-right: 24px;
					}
				}
				.searchable-input {
					width: 257px;
				}
				.reason-number-and-date {
					display: flex;
					width: 257px;
					.input {
						flex-grow: 1;
					}
				}
				::v-deep .np-select {
					width: 200px;
				}
			}
			.act-type {
				margin-bottom: 16px;
			}
			.committee-head .searchable-input,
			.committee-member .searchable-input {
				::v-deep .options-list {
					max-height: 100px;
				}
			}
			.recorded-amount {
				.input {
					width: 250px;
				}
			}
			.keys-and-plombetter {
				display: flex;
				.input {
					margin-left: 0;
				}
				.safe-keys,
				.plombeter_number {
					flex-grow: 1;
					margin-bottom: 0;
				}
			}
			.sst-keys {
				margin-top: 24px;
				display: flex;
				.input {
					margin-left: 0;
				}
				.sst-safe-keys-amount,
				.sst-case-keys-amount {
					flex-grow: 1;
					margin-bottom: 0;
				}

				.sst-safe-keys-amount {
					.label {
						font-size: 12px;
					}
				}
			}
			.reason {
				margin: 16px 0px;
				& .textarea {
					::v-deep textarea {
						height: 80px;
					}
				}
			}
		}
		.buttons {
			display: flex;
			justify-content: space-between;
			flex-direction: row-reverse;
			margin-top: 24px;
			text-align: center;
			& .button:first-child {
				margin-right: 10px;
			}
		}
	}
}
</style>
